import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';

import {merge} from '#core/utils/config-utils.js';
import {flopShadow, resolveBackground} from '#core/utils/color-utils.js';
import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {Betslip} from '#core/application/modules/betting-center/betslip/betslip.js';
import {generateDotNotification} from '#core/application/modules/tiles/dot-notification/index.js';

import {Interface} from '../interface.js';

import PALETTE_SCHEMA from './mobile-nav-bar.palette-schema.yaml';
import SCHEMA from './mobile-nav-bar.schema.yaml';

const {NOTIFICATIONS} = MojitoModules.QuickLinks.types;

class MobileNavBarFeature extends AbstractVisualFeature {
    get name() {
        return 'Mobile NavBar';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return {
            QuickLinks: {
                isDotNotificationVisible: true,
                dotNotification: merge(generateDotNotification(PALETTE.DOT_NOTIFICATION), {
                    style: {
                        container: {
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                        },
                    },
                }),
                container: {
                    style: {
                        height: 48,
                        boxShadow: flopShadow(PALETTE.CONTAINER_SHADOW),
                        ...resolveBackground(PALETTE.CONTAINER_BG),
                        ...(PALETTE.CONTAINER_BORDER_RADIUS > 0
                            ? {
                                  borderRadius: `${PALETTE.CONTAINER_BORDER_RADIUS}px ${PALETTE.CONTAINER_BORDER_RADIUS}px 0 0`,
                              }
                            : {}),
                    },
                },
                linksContainer: Betslip.isFloating
                    ? {
                          style: {
                              gridTemplateColumns: 'repeat(auto-fit, minmax(50px, 1fr))',
                          },
                      }
                    : {
                          nthSeparator: {
                              1: null,
                          },
                          style: {
                              gridTemplateColumns: '1fr 1fr 80px 1fr 1fr', // not retail
                          },
                      },
                linkContainer: {
                    itemSpacing: 4,
                },
                // better to leave it like it is now
                linkIcon: {
                    style: {
                        minHeight: 16,
                        minWidth: 16,
                        fill: PALETTE.ICON_COLOR,
                    },
                },
                linkLabel: {
                    style: {
                        whiteSpace: 'nowrap',
                        ...PALETTE.LABEL_TEXT,
                    },
                },
                links: this.getQuickLinksConfig(PALETTE),
            },
        };
    }

    getQuickLinksConfig(PALETTE) {
        let links = buildIntentsFromConfig(this.config.mobileNavigationBarItems);
        const linkStyleOverrides = PALETTE?.LINK_STYLE_OVERRIDES;

        return links.map(link => {
            if (link.intent.type === MojitoPresentation.Base.Intent.Types.SHOW_SLIDING_OPEN_BETS) {
                link.notification = {
                    onActions: [NOTIFICATIONS.HAS_OPEN_BETS],
                };
            }

            if (linkStyleOverrides?.[link.label]) {
                return merge(link, linkStyleOverrides[link.label]);
            }

            return link;
        });
    }
}

new MobileNavBarFeature(Interface);
